import { ReapplyAddress } from 'api/AuthApi';
import { RoutePath } from 'enums/Routes';
import { ReapplyEditField } from 'handlers/reapplyData';
import { formatDate, formatMonthYear } from 'utils/dateUtils';

export const EDIT_FIELD_TO_ROUTE: Record<ReapplyEditField, RoutePath> = {
  [ReapplyEditField.Email]: RoutePath.YourEmail,
  [ReapplyEditField.Address]: RoutePath.YourAddress,
  [ReapplyEditField.Employment]: RoutePath.YourEmployer,
  [ReapplyEditField.CredentialDate]: RoutePath.YourEmployer,
  [ReapplyEditField.Income]: RoutePath.YourIncome,
  [ReapplyEditField.AdditionalIncome]: RoutePath.AdditionalIncome,
};

export const formatAddress = (address?: ReapplyAddress) => {
  if (!address) return '';

  return [address.street, address.city, [address.stateOrProvince, address.zipOrPostalCode].filter(Boolean).join(' ')]
    .filter(Boolean)
    .join(', ');
};

export const formatDisplayDate = (dateString?: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return Number.isNaN(date.getTime()) ? dateString : formatDate(date);
};

export const formatCredentialDate = (dateString?: string) => {
  if (!dateString) return '';

  const trimmed = dateString.trim();
  // Masked values like "**/2027" and year-only values are shown as returned.
  const fullDate = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!fullDate) return trimmed;

  const [, month, , year] = fullDate;
  return formatMonthYear(new Date(Number(year), Number(month) - 1, 1));
};

export const formatLast4SSN = (last4SSN: string) => `***-***-${last4SSN}`;
